import React from 'react';
import { Avatar } from '@business/workflows/ComponentUI/Avatar';

interface AvatarGroupProps {
  avatars: Array<{
    id: string;
    src?: string;
    alt?: string;
  }>;
  maxDisplay?: number;
  size?: string;
  /** Actual total number of people, when it's larger than `avatars.length` (e.g. API only sends a preview list). Defaults to `avatars.length`. */
  totalCount?: number;
}

export const AvatarGroup: React.FC<AvatarGroupProps> = ({
  avatars,
  maxDisplay = 4,
  size = 'h-7 w-7',
  totalCount
}) => {
  const displayAvatars = avatars.slice(0, maxDisplay);
  const remainingCount = (totalCount ?? avatars.length) - displayAvatars.length;

  return (
    <div className="flex items-center">
      {displayAvatars.map((avatar, index) => (
        <div
          key={avatar.id}
          className={`${index > 0 ? '-ml-2' : ''} relative`}
          style={{ zIndex: displayAvatars.length - index }}>
          <Avatar
            src={avatar.src}
            alt={avatar.alt || 'Avatar'}
            size={size}
            className="border-2 border-white"
          />
        </div>
      ))}
      {remainingCount > 0 && (
        <div
          className={`-ml-2 ${size} rounded-full bg-[#F5F5F5] border-2 border-white flex items-center justify-center text-xs font-medium text-[#505050]`}
          style={{ zIndex: 0 }}>
          +{remainingCount}
        </div>
      )}
    </div>
  );
};
